import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  StateStoring,
  Format,
  Lookup,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCategoriaServicoDs, criarServicosIssDs } from "../../DataSources";

const localStorageKey = "cadastroServicoIssGridState";

export default class ServicosIssBox extends React.Component {
  constructor(props) {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
  }

  filtrar(e) {
    let filtro = this.state.filtro;
    let filtroCorrente = [];

    if (filtro.lcFederal !== undefined && filtro.lcFederal !== "") {
      filtroCorrente.push(["lcFederal", "contains", filtro.lcFederal.trim()]);
    }
    if (filtro.lcMunicipal !== undefined && filtro.lcMunicipal !== "") {
      filtroCorrente.push(["lcMunicipal", "contains", filtro.lcMunicipal.trim()]);
    }
    if (filtro.codigoRfb !== undefined && filtro.codigoRfb !== "") {
      filtroCorrente.push(["codigoRfb", "contains", filtro.codigoRfb.trim()]);
    }
    if (filtro.descricao !== undefined && filtro.descricao !== "") {
      filtroCorrente.push(["descricaoRfb", "contains", filtro.descricao.trim()]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("servicosiss/editar/" + e.data.id);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={6}
            labelLocation={"top"}
          >
            <SimpleItem dataField="codigoRfb" colSpan={1}>
              <Label text="Código RFB" />
            </SimpleItem>
            <SimpleItem dataField="lcFederal" colSpan={1}>
              <Label text="Código LCP 116" />
            </SimpleItem>
            <SimpleItem dataField="lcMunicipal" colSpan={1}>
              <Label text="Código Municipal" />
            </SimpleItem>

            <SimpleItem dataField="descricao" colSpan={3}>
              <Label text="Descrição RFB" />
            </SimpleItem>
          </Form>
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "left",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <PaginaToolbar titulo="SERVIÇOS" novoCb={this.novoRegistro.bind(this)}>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={criarServicosIssDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
            filterSyncEnabled={true}
            onEditingStart={this.onAtualizandoRow}
          >
            <Editing
              allowAdding={false}
              allowUpdating={this.onSelecionado === undefined}
              allowDeleting={this.onSelecionado === undefined}
              useIcons={true}
            />
            <Column
              type="buttons"
              width={60}
              buttons={[
                "edit",
                "delete",
                {
                  icon: "repeat",
                  visible: this.onSelecionado != undefined,
                  onClick: this.onSelecionado,
                },
              ]}
            />
            <Column dataField={"id"} visible={false}>
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"prefeituraId"} visible={false}>
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              dataField={"sequencial"}
              caption={"#"}
              allowEditing={false}
              width={80}
              alignment={"center"}
            />

            <Column
              dataField={"lcMunicipal"}
              caption={"Cód. Municipal"}
              width={100}
            />
            <Column
              dataField={"lcFederal"}
              caption={"Cód. LCP116"}
              width={90}
            />
            <Column
              dataField={"codigoRfb"}
              caption={"Cód. RFB"}
              width={90} sortIndex={1} sortOrder={"asc"}
            />
            <Column
              dataField={"aliquotaIss"}
              caption={"Alíquota ISS"}
              width={90}
            >
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Column
              dataField={"aliquotaIrrfPj"}
              caption={"Alíquota IRRF PJ"}
              width={90}
              visible={false}
            >
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Column
              dataField={"aliquotaInssPj"}
              caption={"Alíquota INSS PJ"}
              visible={false}
              width={90}
            >
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Column dataField={"descricaoRfb"} caption={"Descrição RFB"} wordWrapEnabled={true} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("servicosiss/novo");
  }
}
